import React from 'react';
import { motion } from 'framer-motion';
import { Mail, MapPin, Instagram, Twitter, Linkedin, Youtube } from 'lucide-react';
import sparkLogo from '../assets/spark-logo.png';

const socialLinks = [
  { icon: Instagram, label: 'Instagram', color: '#E4405F', url: 'https://www.instagram.com/sparkcampusapp' },
  { icon: Twitter, label: 'X', color: '#1DA1F2', url: 'https://x.com/sparkcampusapp' },
  { icon: Linkedin, label: 'LinkedIn', color: '#0A66C2', url: 'https://www.linkedin.com/company/sparkcampusapp' },
  { icon: Youtube, label: 'YouTube', color: '#FF0000', url: 'https://www.youtube.com/@sparkcampusapp' },
];

export const Footer = () => {
  return (
    <footer className="relative py-12 px-4 border-t border-sp-border">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Logo and tagline */}
          <div className="md:col-span-3">
            <div className="flex items-center gap-3 mb-4 cursor-pointer relative">
              <img src={sparkLogo} alt="Spark" className="h-6 w-auto opacity-90 filter drop-shadow-[0_0_8px_var(--sp-glow)]" />
            </div>
            <p className="text-sp-text-secondary mb-6 max-w-md">
  The Dual-Identity Campus Social Network.
</p>
            
            {/* Social Icons */}
            <div className="flex gap-4">
              {socialLinks.map((social, index) => {
                const Icon = social.icon;
                return (
                  <motion.a
                    key={index}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="glass-card p-2.5 rounded-full group relative"
                    whileHover={{ scale: 1.1, y: -5 }}
                    whileTap={{ scale: 0.95 }}
                    aria-label={social.label}
                  >
                    <Icon className="w-5 h-5 text-sp-text-secondary group-hover:text-sp-cyan transition-colors duration-300" />
                    
                    {/* Glow effect */}
                    <div
                      className="absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                      style={{
                        boxShadow: `0 0 20px ${social.color}50`,
                      }}
                    />
                  </motion.a>
                );
              })}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sp-text font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {['Explore', 'Community', 'Get Started', 'Contact'].map((link) => (
                <li key={link}>
                  <a
                    href={`/info/${link.replace(' ', '-').toLowerCase()}`}
                    className="text-gray-400 hover:text-[#0BD9E5] transition-colors"
                  >
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-sp-border pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sp-text-secondary text-sm text-center md:text-left">
              © 2026 Spark Platforms, Inc.
            </p>
            <div className="flex flex-wrap gap-6 justify-center">
              <a
                href="https://www.sparkpl.com/privacy-policy.html"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sp-text-secondary hover:text-sp-cyan text-sm transition-colors duration-200 text-center"
              >
                Privacy Policy
              </a>
              <a
                href="https://www.sparkpl.com/terms-and-conditions.html"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sp-text-secondary hover:text-sp-cyan text-sm transition-colors duration-200 text-center"
              >
                Terms of Service
              </a>
              <a
                href="https://www.sparkpl.com/child-safety-standards.html"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sp-text-secondary hover:text-sp-cyan text-sm transition-colors duration-200 text-center"
              >
                Child Safety Policy
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Animated background gradient */}
      <motion.div
        className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[var(--sp-cyan)] to-transparent opacity-30"
        animate={{ opacity: [0.3, 0.6, 0.3] }}
        transition={{ duration: 3, repeat: Infinity, ease: 'easeInOut' }}
      />
    </footer>
  );
};

export default Footer;



